module.exports = __webpack_public_path__ + "img/logo.ca637e08.png";